import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getAuth, onAuthStateChanged, onIdTokenChanged } from "firebase/auth";
import { apolloErrorLink } from "../error/apolloErrorLink";

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_API,
});

const auth = getAuth();

onAuthStateChanged(auth, async (user) => {
  if (user) {
    const token = await user.getIdToken(true);
    localStorage.setItem("idtoken", token);
    localStorage.setItem(
      "user",
      JSON.stringify({ uid: user.uid, email: user.email })
    );
  } else {
    localStorage.removeItem("idtoken");
    localStorage.removeItem("user");
  }
});

onIdTokenChanged(auth, async (user) => {
  if (user) {
    const token = await user.getIdToken();
    localStorage.setItem("idtoken", token);
  }
});

const refreshToken = async () => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken(true);
    localStorage.setItem("idtoken", token);
  }
};

setInterval(refreshToken, 55 * 60 * 1000); // 55 minutes

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("idtoken");
  const user = JSON.parse(localStorage.getItem("user"));

  return {
    headers: {
      ...headers,
      clientid: user?.uid || "",
      authorization: token || "",
    },
  };
});

const client = new ApolloClient({
  // Compose error logging first to capture downstream link errors
  link: from([apolloErrorLink, authLink, httpLink]),
  cache: new InMemoryCache(),
});

export default client;
